import { staticPriceTypes } from '@constants/orderManagement'
import { DeleteFilled } from '@ant-design/icons'
import { BBDTag, GraviButton, Texto } from '@gravitate-js/excalibrr'
import { Col, Form, Input, InputNumber, Popover, Row, Select } from 'antd'
import React, { useRef } from 'react'
import _ from 'lodash'

const { Option } = Select
export function BolDetailRow({ index, suppliers, products, removeRow, bolDetail, editing, fields, isBackhaul }) {
  const supplierWrapperRef = useRef(null)
  const productWrapperRef = useRef(null)
  const pocketWrapperRef = useRef(null)
  const priceTypeWrapperRef = useRef(null)

  const canDelete = fields.length > 1
  if (!editing) return <BOLDetailDisplay bolDetail={bolDetail} />
  return (
    <Row className='p-3 detail-row'>
      <Col align='left' span={4}>
        <div ref={supplierWrapperRef}>
          <Form.Item name={[index, 'supplier']} rules={[{ required: true, message: 'Supplier is Required' }]}>
            <Select
              allowClear
              style={{ width: '95%' }}
              showSearch
              placeholder='Search For Suppliers'
              getPopupContainer={(_) => supplierWrapperRef?.current}
            >
              {suppliers?.map((s, i) => (
                <Option key={i} value={s}>
                  {s}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      </Col>
      <Col align='left' span={4}>
        <div ref={productWrapperRef}>
          <Form.Item name={[index, 'product']} rules={[{ required: true, message: 'Product is Required' }]}>
            <Select
              allowClear
              style={{ width: '95%' }}
              showSearch
              placeholder='Search For Products'
              getPopupContainer={(_) => productWrapperRef?.current}
            >
              {products?.map((p, i) => (
                <Option key={i} value={p}>
                  {p}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      </Col>
      <Col align='left' span={3}>
        <Form.Item rules={[{ required: false }]} name={[index, 'contract']}>
          <Input placeholder='Contract' style={{ width: '95%' }} />
        </Form.Item>
      </Col>
      <Col align='left' span={3}>
        <Form.Item rules={[{ required: true, message: 'Net Volume is Required' }]} name={[index, 'net']}>
          <InputNumber placeholder='Net Volume' style={{ width: '95%' }} />
        </Form.Item>
      </Col>
      <Col align='left' span={3}>
        <Form.Item rules={[{ required: true, message: 'Gross Volume is Required' }]} name={[index, 'gross']}>
          <InputNumber placeholder='Gross Volume' style={{ width: '95%' }} />
        </Form.Item>
      </Col>
      <Col span={isBackhaul ? 6 : 3}>
        <div ref={pocketWrapperRef}>
          <Form.Item name={[index, 'pocket']}>
            <Select
              showSearch
              style={{ width: '80%' }}
              placeholder='Compartment No.'
              getPopupContainer={(_) => pocketWrapperRef?.current}
            >
              <Option value={null}>Load</Option>
              <Option value={1}>1</Option>
              <Option value={2}>2</Option>
              <Option value={3}>3</Option>
              <Option value={4}>4</Option>
              <Option value={5}>5</Option>
            </Select>
          </Form.Item>
        </div>
      </Col>
      {!isBackhaul && (
        <Col span={3}>
          <div ref={priceTypeWrapperRef}>
            <Form.Item name={[index, 'price_type']}>
              <Select
                showSearch
                style={{ width: '80%' }}
                placeholder='Price Type'
                getPopupContainer={(_) => priceTypeWrapperRef?.current}
              >
                {staticPriceTypes?.map((p) => (
                  <Option key={p.value} value={p.value}>
                    {p.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        </Col>
      )}
      <Col span={1} align='right'>
        {canDelete ? (
          <GraviButton
            className='delete-drop-button'
            icon={<DeleteFilled className='delete-drop' />}
            onClick={removeRow}
          />
        ) : (
          <Popover content='You cannot delete the last detail of a BOL' placement='bottomRight'>
            <div>
              <GraviButton
                className='delete-drop-button'
                icon={<DeleteFilled className='delete-drop' />}
                onClick={removeRow}
                disabled
              />
            </div>
          </Popover>
        )}
      </Col>
    </Row>
  )
}
function BOLDetailDisplay({ bolDetail, isBackhaul }) {
  if (!bolDetail) return null
  return (
    <Row className='p-3 detail-row'>
      <Col align='left' span={4}>
        <Texto>{bolDetail.supplier}</Texto>
      </Col>
      <Col align='left' span={4}>
        <Texto>{bolDetail.product}</Texto>
      </Col>
      <Col align='left' span={4}>
        <Texto>{bolDetail.contract || 'N/A'}</Texto>
      </Col>
      <Col align='left' span={3}>
        <Texto>{bolDetail.net}</Texto>
      </Col>
      <Col align='left' span={3}>
        <Texto>{bolDetail.gross}</Texto>
      </Col>
      <Col span={isBackhaul ? 6 : 3}>
        <BBDTag theme2>{bolDetail.pocket || 'BY TOTAL'}</BBDTag>
      </Col>
      {!isBackhaul && (
        <Col span={3}>
          <Texto style={{ textTransform: 'capitalize' }}>{bolDetail.price_type || ''}</Texto>
        </Col>
      )}
    </Row>
  )
}
